exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel[data-v-5f436604]{position:absolute;right:0}", ""]);

// exports
